import React from 'react';
import css from './ServerMsg.module.scss';

const ServerMsg = () => (
    <div className={css.serverMsgContainer}>
        <div className={css.serverMsgBox}>
            <p className={css.serverMsg}>
                This site was designed for the latest version of Chrome, Firefox, Safari, and Microsoft Edge Chromium.
                Please use another internet browser.
            </p>
        </div>
    </div>
);

export default ServerMsg;